module.exports = __webpack_public_path__ + "static/media/26.0b104c3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/26.jpg
// module id = 967
// module chunks = 0